import {
  Route,
  createHashRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import { useSelector } from "react-redux";

import ProtectedRoute from "./ProtectedRoute/ProtectedRoute.security";
import Login from "./containers/Login/Login.container";
import Dashboard from "./containers/Dashboard/Dashboard.container";
import Transactions from "./containers/Transactions/Transactions.container";
import TransactionsView from "./containers/TransactionView/TransactionView.container";
import Customers from "./containers/Customers/Customers.container";
import CustomerView from "./containers/CustomerView/CustomerView.container";
import PrivacyPolicy from "./static-pages/PrivacyPolicy.static";
import Mechanics from "./static-pages/Mechanics";
import Redemptions from "./containers/Redemptions/Redemptions.container";
import Raffle from "./containers/Raffle/Raffle.container";
import Winners from "./containers/Winners/Winners.container";
import Ads from "./containers/Ads/Ads.container";

import "./App.scss";
import RootLayout from "./hoc/RootLayout";

const App = () => {
  const cmsAuth = useSelector((state) => state.cmsAuthenticator.cmsAuth || "");

  const router = createHashRouter(
    createRoutesFromElements(
      <Route path="/" element={<RootLayout />}>
        <Route path="/login" element={<Login />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute auth={cmsAuth}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="transactions"
          element={
            <ProtectedRoute auth={cmsAuth}>
              <Transactions />
            </ProtectedRoute>
          }
        />
        <Route
          path="transactions/:id"
          element={
            <ProtectedRoute auth={cmsAuth}>
              <TransactionsView />
            </ProtectedRoute>
          }
        />
        <Route
          path="customers"
          element={
            <ProtectedRoute auth={cmsAuth}>
              <Customers />
            </ProtectedRoute>
          }
        />
        <Route
          path="customers/:id"
          element={
            <ProtectedRoute auth={cmsAuth}>
              <CustomerView />
            </ProtectedRoute>
          }
        />

        <Route
          path="redemptions"
          element={
            <ProtectedRoute auth={cmsAuth}>
              <Redemptions />
            </ProtectedRoute>
          }
        />

        <Route
          path="raffle"
          element={
            <ProtectedRoute auth={cmsAuth}>
              <Raffle />
            </ProtectedRoute>
          }
        />
        <Route
          path="winners"
          element={
            <ProtectedRoute auth={cmsAuth}>
              <Winners />
            </ProtectedRoute>
          }
        />

        <Route
          path="ads"
          element={
            <ProtectedRoute auth={cmsAuth}>
              <Ads />
            </ProtectedRoute>
          }
        />

        <Route exact path="privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="mechanics" element={<Mechanics />} />
        <Route exact path="/" element={<Login />} />
        <Route path="*" element={<p>There's nothing here: 404!</p>} />
      </Route>
    )
  );
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default App;
